import { renderDate, renderDateValue } from '../utility/addressTabGridHelper';
import { renderBooleanText } from '../utility/dictionaryGridHelper';

export const SOP_GRID_COLUMNS = [
  {
    field: 'SOPID',
    headerName: 'Title',
    width: 200,
    valueGetter: (params) => params.row.SOP?.SOPID,
  },
  {
    field: 'DispatcherMessage',
    headerName: 'Dispatcher Message',
    width: 200,
    valueGetter: (params) => params.row.SOP?.DispatcherMessage,
  },
  {
    field: 'AlertMessage',
    headerName: 'Alert Message',
    width: 200,
    valueGetter: (params) => params.row.SOP?.AlertMessage,
  },
  {
    field: 'IsPagingMessageUsed',
    headerName: 'Is Paging Used',
    width: 160,
    type: 'boolean',
    valueGetter: (params) => params.row.SOP?.IsPagingMessageUsed,
  },
  {
    field: 'ShowToast',
    headerName: 'Popup Notification',
    width: 170,
    type: 'boolean',
    valueGetter: (params) => params.row.SOP?.ShowToast,
  },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 150 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 150 },
];

export const SOP_DETAIL_FIELDS = [
  {
    field: 'SOPID',
    label: 'Title',
    valueGetter: (row) => row.SOP?.SOPID,
  },
  {
    field: 'DispatcherMessage',
    label: 'Dispatcher Message',
    valueGetter: (row) => row.SOP?.DispatcherMessage,
  },
  {
    field: 'AlertMessage',
    label: 'Alert Message',
    valueGetter: (row) => row.SOP?.AlertMessage,
  },
  {
    field: 'IsApproved',
    label: 'Is Approved',
    valueGetter: (row) => row.SOP?.IsApproved,
    render: renderBooleanText,
  },
  {
    field: 'Approved',
    label: 'Approved',
    valueGetter: (row) => row.SOP?.Approved,
  },
  {
    field: 'Flags',
    label: 'Flags',
    valueGetter: (row) => row.SOP?.Flags,
  },
  {
    field: 'IsAlertMessageUsed',
    label: 'Is Alert Message Used',
    valueGetter: (row) => row.SOP?.IsAlertMessageUsed,
    render: renderBooleanText,
  },
  {
    field: 'IsPagingMessageUsed',
    label: 'Is Paging Message Used',
    valueGetter: (row) => row.SOP?.IsPagingMessageUsed,
    render: renderBooleanText,
  },
  {
    field: 'PagingMessage',
    label: 'Paging Message',
    valueGetter: (row) => row.SOP?.PagingMessage,
  },
  {
    field: 'ShowToast',
    label: 'Popup Notification',
    valueGetter: (row) => row.SOP?.ShowToast,
    render: renderBooleanText,
  },
  { field: 'CreatedBy', label: 'Created By' },
  { field: 'Updated', label: 'Updated', render: renderDateValue },
  { field: 'UpdatedBy', label: 'Updated By' },
  {
    field: 'IsDeleted',
    label: 'Is Deleted',
    render: renderBooleanText,
  },
  { field: 'DeletedBy', label: 'Deleted By' },
  { field: 'DeletedIP', label: 'Deleted IP' },
];
